import { useState } from 'react';
import {
  FaBan,
  FaCheckCircle,
  FaClipboardList,
  FaClock,
  FaCompass,
  FaCopy,
  FaDownload,
  FaEnvelope,
  FaExclamationTriangle,
  FaFileAlt,
  FaInfoCircle,
  FaLightbulb,
  FaMapMarkerAlt,
  FaPaperclip,
  FaPen,
  FaPlug,
  FaQuestionCircle,
  FaRegClock,
} from 'react-icons/fa';
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import { STRELETS_EMAIL } from '../../constants/contactInfo.js';
import './AppealsInstructionsPage.css';

const RECIPIENT_EMAIL = STRELETS_EMAIL;

const templates = {
  reglament: `Исх. № ___ от ДД.ММ.ГГГГ

УВЕДОМЛЕНИЕ
«О проведении регламентных работ систем противопожарной защиты (СПЗ) на объекте защиты»

В соответствии с пунктом 7.1 Порядка организации дублирования сигналов о возникновении пожара в подразделения пожарной охраны на территории Самарской области, утвержденного постановлением Правительства Самарской области от 07.05.2026 № 297, уведомляем о необходимости перевода системы передачи извещений о пожаре в режим «Регламент» в связи с проведением регламентных работ на объекте.

1. Сведения об объекте защиты:
1.1. Наименование объекта защиты:
1.2. Адрес объекта защиты (полный):
2. Сведения о дате и времени начала и окончания работ:
2.1. ДД.ММ.ГГГГ с ЧЧ:ММ – ЧЧ:ММ;
3. Должностное лицо, ответственное за взаимодействие с организацией, осуществляющей техническое обслуживание прибора пультового оконечного, на период проведения работ:
3.1. Ф.И.О.:
3.2. Должность:
3.3. Контактный телефон:
3.4. Адрес электронной почты:
4. Основание / цель проведения работ:

Прошу перевести работу системы передачи извещений о пожаре на указанном объекте в режим «Регламент» в заявленный период времени. В случае изменения сроков завершения работ обязуюсь проинформировать дополнительно.

Руководитель объекта защиты

		М.П.	(подпись)	Фамилия И.О.

«ДД» месяца ГГГГ г.`,
  repair: `Исх. № ___ от ДД.ММ.ГГГГ

УВЕДОМЛЕНИЕ
«О проведении ремонтных работ систем противопожарной защиты (СПЗ) на объекте защиты»

В соответствии с пунктом 7.1 Порядка организации дублирования сигналов о возникновении пожара в подразделения пожарной охраны на территории Самарской области, утвержденного постановлением Правительства Самарской области от 07.05.2026 № 297, уведомляем о необходимости перевода системы передачи извещений о пожаре в режим «Ремонт» в связи с проведением длительных ремонтных работ на объекте.

1. Сведения об объекте защиты:
1.1. Наименование объекта защиты:
1.2. Адрес объекта защиты (полный):
2. Сведения о дате и времени начала и окончания работ:
2.1. с ДД.ММ.ГГГГ до ДД.ММ.ГГГГ
3. Должностное лицо, ответственное за взаимодействие с организацией, осуществляющей техническое обслуживание прибора пультового оконечного, на период проведения работ:
3.1. Ф.И.О.:
3.2. Должность:
3.3. Контактный телефон:
3.4. Адрес электронной почты:
4. Основание / цель проведения работ:

Прошу перевести работу системы передачи извещений о пожаре на указанном объекте в режим «Ремонт» в заявленный период времени. В случае изменения сроков завершения работ обязуюсь проинформировать дополнительно.

Руководитель объекта защиты

		М.П.	(подпись)	Фамилия И.О.

«ДД» месяца ГГГГ г.`,
  soz: `Исх. № ___ от ДД.ММ.ГГГГ

ЗАЯВЛЕНИЕ
«Об изменении сведений об объекте защиты, содержащихся в электронной карточке объекта защиты»

В соответствии с пунктом 5.2 Порядка организации дублирования сигналов о возникновении пожара в подразделения пожарной охраны на территории Самарской области, утвержденного постановлением Правительства Самарской области от 07.05.2026 № 297, уведомляем об изменении сведений об объекте защиты, содержащихся в электронной карточке объекта защиты, и просим внести соответствующие изменения.

1. Сведения об объекте защиты:
1.1. Наименование объекта защиты:
1.2. Адрес объекта защиты (полный):
2. Изменяемые сведения (при изменениях):
2.1. Наименование объекта защиты:
2.2. Адрес объекта защиты (полный):
2.3. Адрес электронной почты:
2.4. Данные лиц, допущенных к эксплуатации системы передачи извещений о пожаре (дежурный персонал):
2.5. Сведения о лицах, ответственных за обеспечение пожарной безопасности на объекте защиты (не менее двух человек), с указанием фамилии, имени, отчества, занимаемой должности и контактного телефона:
2.6. Руководитель объекта защиты с указанием контактного телефона:
2.7. Иные сведения:

Прошу внести указанные изменения в электронную карточку объекта защиты.

Руководитель объекта защиты

		М.П.	(подпись)	Фамилия И.О.

«ДД» месяца ГГГГ г.`,
  tz: `Исх. № ___ от ДД.ММ.ГГГГ

ЗАЯВЛЕНИЕ
«О выдаче технического задания на проектирование»

В соответствии с пунктом 4.1 Порядка организации дублирования сигналов о возникновении пожара в подразделения пожарной охраны на территории Самарской области, утвержденного постановлением Правительства Самарской области от 07.05.2026 № 297, прошу выдать техническое задание на проектирование для подключения системы пожарной сигнализации объекта защиты к прибору пультовому оконечному через прибор объектовый оконечный системы передачи извещений о пожаре.

1. Сведения о правообладателе объекта защиты:
1.1. Наименование (Ф.И.О. — для индивидуального предпринимателя):
1.2. ИНН / ОГРН (ОГРНИП):
1.3. Юридический (почтовый) адрес:
1.4. Физический адрес объекта защиты:
1.5. Ф.И.О.:
1.6. Контактный телефон:
1.7. Адрес электронной почты:

Прошу выдать техническое задание на проектирование.

Руководитель объекта защиты

		М.П.	(подпись)	Фамилия И.О.

«ДД» месяца ГГГГ г.`,
  connection: `Исх. № ___ от ДД.ММ.ГГГГ

ЗАЯВЛЕНИЕ
«О подключении системы пожарной сигнализации объекта защиты к прибору пультовому оконечному ПАК «Стрелец-Мониторинг»»

В соответствии с пунктом 4.2 Порядка организации дублирования сигналов о возникновении пожара в подразделения пожарной охраны на территории Самарской области, утвержденного постановлением Правительства Самарской области от 07.05.2026 № 297, прошу осуществить подключение прибора объектового оконечного системы передачи извещений о пожаре, установленного на объекте защиты, к прибору пультовому оконечному ПАК «Стрелец-Мониторинг».

1. Сведения о правообладателе объекта защиты:
1.1. Наименование (Ф.И.О. — для индивидуального предпринимателя):
1.2. ИНН / ОГРН (ОГРНИП):
1.3. Юридический (почтовый) адрес:
1.4. Контактный телефон, адрес электронной почты:
2. Сведения об объекте защиты:
2.1. Наименование объекта защиты:
2.2. Адрес объекта защиты (полный):
3. Сведения об установленном приборе объектовым оконечном:
3.1. Тип (модель):
3.2. Заводской (серийный) номер:
4. Ответственное (контактное) лицо:
4.1. Ф.И.О., должность, контактный телефон, адрес электронной почты:

Прошу рассмотреть представленные документы и осуществить подключение системы пожарной сигнализации объекта защиты через прибор объектовый оконечный к прибору пультовому оконечному для проведения комплексного испытания систем противопожарной защиты.

Приложение (перечень документов в соответствии с пунктом 4.2 Порядка):
1. Проектная документация на оснащение объекта защиты прибором объектовым оконечным системы передачи извещений о пожаре.
2. Техническая документация изготовителя на установленный прибор объектовый оконечный системы передачи извещений о пожаре.
3. Акт выполненных работ по монтажу и пусконаладочным работам.
4. Акт ввода в эксплуатацию системы пожарной сигнализации.
5. Копия договора на техническое обслуживание прибора объектового оконечного системы передачи извещений о пожаре.
6. Выписка из электронного сервиса МЧС России «Реестры лицензий МЧС России в области пожарной безопасности».

Руководитель объекта защиты

		М.П.	(подпись)	Фамилия И.О.

«ДД» месяца ГГГГ г.`,
};

const downloads = {
  reglament: {
    href: '/texts/Завявление_на_регламентные_работы.docx',
    name: 'Завявление_на_регламентные_работы.docx',
  },
  repair: {
    href: '/texts/Уведомление_о_ремонтных_работах.docx',
    name: 'Уведомление_о_ремонтных_работах.docx',
  },
  soz: {
    href: '/texts/Заявление об изменении сведений.docx',
    name: 'Заявление об изменении сведений.docx',
  },
  sozCard: {
    href: '/texts/Пример карточки объекта СОЗ.docx',
    name: 'Пример карточки объекта СОЗ.docx',
  },
  tz: {
    href: '/texts/Заявление_на_выдачу_ТЗ_на_проектирование.docx',
    name: 'Заявление_на_выдачу_ТЗ_на_проектирование.docx',
  },
  connection: {
    href: '/texts/Заявление_о_подключении_к_ПАК_Стрелец_Мониторинг.docx',
    name: 'Заявление_о_подключении_к_ПАК_Стрелец_Мониторинг.docx',
  },
};

const tabs = [
  { id: 'reglament', label: 'Уведомление о регламенте' },
  { id: 'repair', label: 'Уведомление о ремонте' },
  { id: 'soz', label: 'Заявление на изменение СОЗ' },
  { id: 'tz', label: 'Заявление на выдачу ТЗ' },
  { id: 'connection', label: 'Заявление на подключение' },
  { id: 'general', label: 'Общие вопросы' },
];

function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);

  return Promise.resolve();
}

function SectionBlock({ icon, title, children, isTemplate }) {
  return (
    <section
      className={`appealsInstructionsPage__block${
        isTemplate ? ' appealsInstructionsPage__block_template' : ''
      }`}
    >
      <h4 className="appealsInstructionsPage__block-title">
        <span className="appealsInstructionsPage__minor-icon">{icon}</span>
        {title}
      </h4>
      {children}
    </section>
  );
}

function Notice({ type = 'tip', icon, children }) {
  return (
    <div
      className={`appealsInstructionsPage__notice appealsInstructionsPage__notice_${type}`}
    >
      <span className="appealsInstructionsPage__notice-icon">{icon}</span>
      <div className="appealsInstructionsPage__notice-content">{children}</div>
    </div>
  );
}

function Schedule() {
  return (
    <div className="appealsInstructionsPage__schedule">
      <div className="appealsInstructionsPage__schedule-row">
        <span className="appealsInstructionsPage__schedule-label">Рабочие дни:</span>
        <span>Пн–Чт: 09:00 – 18:00</span>
        <span>Пт: 09:00 – 17:00</span>
      </div>
      <div className="appealsInstructionsPage__schedule-row">
        <span className="appealsInstructionsPage__schedule-label">Обед:</span>
        <span>13:00 – 13:48</span>
      </div>
      <div className="appealsInstructionsPage__schedule-row">
        <span className="appealsInstructionsPage__schedule-label">
          Приём уведомлений до:
        </span>
        <span>Пн–Чт: 13:00</span>
        <span>Пт: 12:00</span>
      </div>
    </div>
  );
}

function CodeBlock({ children }) {
  return <div className="appealsInstructionsPage__code">{children}</div>;
}

function Rule({ number, title, required, children }) {
  return (
    <article className="appealsInstructionsPage__rule">
      <span className="appealsInstructionsPage__rule-number">{number}</span>
      <div className="appealsInstructionsPage__rule-content">
        <h5 className="appealsInstructionsPage__rule-title">
          {title}
          {required ? (
            <span className="appealsInstructionsPage__required"> {required}</span>
          ) : null}
        </h5>
        {children}
      </div>
    </article>
  );
}

function DetailsList({ children }) {
  return <ul className="appealsInstructionsPage__details">{children}</ul>;
}

function TemplateBlock({ id, title, copiedKey, onCopy }) {
  const download = downloads[id];
  const isCopied = copiedKey === id;

  return (
    <SectionBlock icon={<FaDownload />} title={title} isTemplate>
      <p className="appealsInstructionsPage__text">
        Скопируйте текст в свой бланк или скачайте готовый файл-образец (.docx)
        и отредактируйте под свой объект.
      </p>
      <div className="appealsInstructionsPage__actions">
        <button
          type="button"
          className={`appealsInstructionsPage__button${
            isCopied ? ' appealsInstructionsPage__button_success' : ''
          }`}
          onClick={() => onCopy(id, templates[id])}
        >
          <FaCopy />
          {isCopied ? 'Скопировано' : 'Копировать текст'}
        </button>
        <a
          href={download.href}
          download={download.name}
          className="appealsInstructionsPage__button appealsInstructionsPage__button_secondary"
        >
          <FaDownload />
          Скачать пример (.docx)
        </a>
      </div>
      <pre className="appealsInstructionsPage__template">{templates[id]}</pre>
      <Notice type="tip" icon={<FaLightbulb />}>
        <p>В образце данные выделены как пример. Замените их на сведения вашей организации и объекта.</p>
      </Notice>
    </SectionBlock>
  );
}

function ReglamentTab({ copiedKey, onCopy }) {
  return (
    <InstructionCard icon={<FaClipboardList />} title="Уведомление о проведении регламентных работ">
      <SectionBlock icon={<FaInfoCircle />} title="Нормативное обоснование">
        <p>
          В соответствии с <strong>пунктом 7.1</strong> Порядка организации
          дублирования сигналов о возникновении пожара в подразделения пожарной
          охраны на территории Самарской области, утвержденного постановлением
          Правительства Самарской области <strong>от 07.05.2026 № 297</strong>,
          на период проведения регламентных работ систем противопожарной защиты
          система передачи извещений о пожаре переводится в режим{' '}
          <strong>«Регламент»</strong>.
        </p>
        <p>
          Для перевода в данный режим правообладатель объекта защиты обязан
          заблаговременно направить уведомление с указанием объекта, даты и
          времени начала и окончания работ.
        </p>
      </SectionBlock>

      <SectionBlock icon={<FaClock />} title="Режим работы и сроки подачи уведомлений">
        <Schedule />
        <Notice type="warning" icon={<FaExclamationTriangle />}>
          <p>
            <strong>Важно:</strong> уведомления, поступившие после указанного
            времени, регистрируются и обрабатываются на следующий рабочий день.
            В выходные и праздничные дни обработка не производится.
          </p>
        </Notice>
      </SectionBlock>

      <SectionBlock icon={<FaRegClock />} title="Технические ограничения по времени работ">
        <p>
          Процедура перевода объекта в режим «Регламент» и обратно выполняется
          специалистом вручную и привязана к рабочему времени подразделения.
        </p>
        <div className="appealsInstructionsPage__table">
          <div className="appealsInstructionsPage__table-row appealsInstructionsPage__table-row_header">
            <span>Параметр</span>
            <span>Допустимое значение</span>
          </div>
          <div className="appealsInstructionsPage__table-row">
            <span>Время начала работ</span>
            <strong>Не ранее 09:20</strong>
          </div>
          <div className="appealsInstructionsPage__table-row">
            <span>Предельное время начала работ (Пн–Чт)</span>
            <strong>Не позднее 16:40</strong>
          </div>
          <div className="appealsInstructionsPage__table-row">
            <span>Предельное время начала работ (Пт)</span>
            <strong>Не позднее 15:40</strong>
          </div>
        </div>
        <Notice type="tip" icon={<FaCheckCircle />}>
          <p>
            <strong>Правильный подход:</strong> режим устанавливается строго на
            время фактического проведения работ. По окончании работ охрана должна
            быть немедленно восстановлена.
          </p>
        </Notice>
      </SectionBlock>

      <SectionBlock icon={<FaFileAlt />} title="Требования к оформлению уведомления">
        <p className="appealsInstructionsPage__important">
          Для корректной регистрации и обработки уведомление должно быть
          направлено с соблюдением обязательных правил.
        </p>
        <Rule number="1" title="Тема письма" required="(строго по формату)">
          <CodeBlock>
            РЕГЛАМЕНТ / Полное наименование организации / ДД.ММ.ГГГГ ЧЧ:ММ – ЧЧ:ММ / Исх. №
          </CodeBlock>
          <DetailsList>
            <li>ДД.ММ.ГГГГ — дата проведения регламентных работ.</li>
            <li>ЧЧ:ММ – ЧЧ:ММ — интервал начала и окончания работ по местному времени.</li>
          </DetailsList>
          <Notice type="example" icon={<FaMapMarkerAlt />}>
            <p>
              <strong>Пример:</strong> «РЕГЛАМЕНТ / ООО "Пожарная Безопасность" /
              25.06.2026 10:00 – 12:00 / Исх. № 123»
            </p>
          </Notice>
          <Notice type="danger" icon={<FaBan />}>
            <p>Письма с темой, не соответствующей формату, автоматически направляются в спам и не рассматриваются.</p>
          </Notice>
        </Rule>
        <Rule number="2" title="Вложение" required="(строго один файл)">
          <DetailsList>
            <li>Уведомление оформляется на официальном бланке организации-правообладателя.</li>
            <li>Формат файла: только PDF.</li>
            <li>Количество вложений: ровно одно. Прикреплять скан, фото или архив запрещено.</li>
          </DetailsList>
          <CodeBlock>
            РЕГЛАМЕНТ_Наименование организации.pdf
          </CodeBlock>
        </Rule>
        <Rule number="3" title="Одно уведомление = один объект защиты">
          <p>В одном письме и одном PDF-файле должно содержаться уведомление только по одному объекту защиты.</p>
        </Rule>
        <Rule number="4" title="Отправитель">
          <p>Уведомления принимаются исключительно от правообладателя объекта защиты.</p>
        </Rule>
        <Rule number="5" title="Защита от дублирования">
          <p>Повторная отправка идентичного уведомления автоматически отклоняется как дубликат.</p>
        </Rule>
      </SectionBlock>

      <TemplateBlock id="reglament" title="Готовый образец уведомления" copiedKey={copiedKey} onCopy={onCopy} />
    </InstructionCard>
  );
}

function RepairTab({ copiedKey, onCopy }) {
  return (
    <InstructionCard icon={<FaClipboardList />} title="Уведомление о проведении ремонтных работ">
      <SectionBlock icon={<FaInfoCircle />} title="Нормативное обоснование">
        <p>
          В соответствии с <strong>пунктом 7.1</strong> Порядка организации
          дублирования сигналов о возникновении пожара в подразделения пожарной
          охраны на территории Самарской области, утвержденного постановлением
          Правительства Самарской области <strong>от 07.05.2026 № 297</strong>,
          на период проведения длительных ремонтных работ систем
          противопожарной защиты система передачи извещений о пожаре
          переводится в режим <strong>«Ремонт»</strong>.
        </p>
        <p>
          Для перевода в данный режим правообладатель объекта защиты направляет
          уведомление с указанием объекта, периода проведения работ,
          ответственного лица и основания ремонта.
        </p>
      </SectionBlock>

      <SectionBlock icon={<FaClock />} title="Режим работы и сроки подачи уведомлений">
        <Schedule />
        <Notice type="warning" icon={<FaExclamationTriangle />}>
          <p>
            <strong>Важно:</strong> уведомления, поступившие после указанного
            времени, регистрируются и обрабатываются на следующий рабочий день.
            В выходные и праздничные дни обработка не производится.
          </p>
        </Notice>
      </SectionBlock>

      <SectionBlock icon={<FaRegClock />} title="Период проведения ремонтных работ">
        <p>
          Режим «Ремонт» указывается на период длительных работ с датой начала и
          датой окончания. Если сроки завершения изменились, необходимо
          направить дополнительную информацию.
        </p>
        <Notice type="tip" icon={<FaCheckCircle />}>
          <p>
            <strong>Правильный подход:</strong> указывайте полный период работ в
            формате «ДД.ММ.ГГГГ – ДД.ММ.ГГГГ» и отдельно фиксируйте
            основание или цель ремонта.
          </p>
        </Notice>
      </SectionBlock>

      <SectionBlock icon={<FaFileAlt />} title="Требования к оформлению уведомления">
        <p className="appealsInstructionsPage__important">
          Для корректной регистрации и обработки уведомление должно быть
          направлено с соблюдением обязательных правил.
        </p>
        <Rule number="1" title="Тема письма" required="(строго по формату)">
          <CodeBlock>
            РЕМОНТ / Полное наименование организации / ДД.ММ.ГГГГ – ДД.ММ.ГГГГ / Исх. №
          </CodeBlock>
          <DetailsList>
            <li>ДД.ММ.ГГГГ — даты начала и окончания ремонтных работ.</li>
            <li>Исх. № — исходящий номер уведомления на бланке организации.</li>
          </DetailsList>
          <Notice type="example" icon={<FaMapMarkerAlt />}>
            <p>
              <strong>Пример:</strong> «РЕМОНТ / ООО "Пожарная Безопасность" /
              25.06.2026 – 30.06.2026 / Исх. № 123»
            </p>
          </Notice>
          <Notice type="danger" icon={<FaBan />}>
            <p>Письма с темой, не соответствующей формату, автоматически направляются в спам и не рассматриваются.</p>
          </Notice>
        </Rule>
        <Rule number="2" title="Вложение" required="(строго один файл)">
          <DetailsList>
            <li>Уведомление оформляется на официальном бланке организации-правообладателя.</li>
            <li>Формат файла: только PDF.</li>
            <li>Количество вложений: ровно одно. Прикреплять скан, фото или архив запрещено.</li>
          </DetailsList>
          <CodeBlock>
            РЕМОНТ_Наименование организации.pdf
          </CodeBlock>
        </Rule>
        <Rule number="3" title="Одно уведомление = один объект защиты">
          <p>В одном письме и одном PDF-файле должно содержаться уведомление только по одному объекту защиты.</p>
        </Rule>
        <Rule number="4" title="Отправитель">
          <p>Уведомления принимаются исключительно от правообладателя объекта защиты.</p>
        </Rule>
        <Rule number="5" title="Изменение сроков работ">
          <p>Если сроки завершения ремонтных работ изменились, направьте дополнительное уведомление.</p>
        </Rule>
      </SectionBlock>

      <TemplateBlock id="repair" title="Готовый образец уведомления" copiedKey={copiedKey} onCopy={onCopy} />
    </InstructionCard>
  );
}

function SozTab({ copiedKey, onCopy }) {
  return (
    <InstructionCard icon={<FaPen />} title="Заявление на изменение Сведений об объекте защиты">
      <SectionBlock icon={<FaInfoCircle />} title="Нормативное обоснование">
        <p>
          В соответствии с <strong>пунктом 5.2</strong> Порядка, правообладатель
          объекта защиты направляет уведомление об изменении сведений, содержащихся
          в электронной карточке объекта.
        </p>
        <ul className="appealsInstructionsPage__list">
          <li>адрес электронной почты;</li>
          <li>данные лиц, допущенных к эксплуатации системы передачи извещений о пожаре;</li>
          <li>номера телефонов;</li>
          <li>иные сведения, содержащиеся в карточке объекта защиты.</li>
        </ul>
      </SectionBlock>

      <SectionBlock icon={<FaClock />} title="Режим работы и сроки подачи уведомлений">
        <Schedule />
        <Notice type="warning" icon={<FaExclamationTriangle />}>
          <ul>
            <li>Заявления после контрольного времени обрабатываются на следующий рабочий день.</li>
            <li>В выходные и праздничные дни обработка не производится.</li>
            <li>Изменения вносятся вручную, поэтому заявление лучше подавать заранее.</li>
          </ul>
        </Notice>
      </SectionBlock>

      <SectionBlock icon={<FaRegClock />} title="Технические ограничения">
        <p>
          Процедура внесения изменений требует времени на проверку данных и
          обновление информационной системы.
        </p>
        <Notice type="tip" icon={<FaLightbulb />}>
          <p>
            Рекомендуем подавать уведомление минимум за 2–3 рабочих дня до даты,
            когда обновленные сведения должны быть учтены.
          </p>
        </Notice>
      </SectionBlock>

      <SectionBlock icon={<FaFileAlt />} title="Требования к оформлению заявления">
        <Rule number="1" title="Тема письма" required="(строго по формату)">
          <CodeBlock>СОЗ / Полное наименование организации / ДД.ММ.ГГГГ / Исх. №</CodeBlock>
          <Notice type="example" icon={<FaMapMarkerAlt />}>
            <p><strong>Пример:</strong> «СОЗ / ООО "Пожарная Безопасность" / 25.06.2026 / Исх. № 45»</p>
          </Notice>
        </Rule>
        <Rule number="2" title="Вложения" required="(строго два файла)">
          <p>Письмо должно содержать ровно два вложения в формате PDF:</p>
          <div className="appealsInstructionsPage__attachments">
            <Attachment number="1." title="Заявление о внесении изменений" text="Заявление с перечнем изменяемых данных и новыми значениями." />
            <Attachment number="2." title="Сведения об объекте защиты" text="Заполненная актуальная карточка объекта с учетом изменений." />
          </div>
        </Rule>
        <Rule number="3" title="Имя файлов" required="(строго по формату)">
          <p><strong>Файл 1:</strong></p>
          <CodeBlock>СОЗ_Заявление_Наименование организации.pdf</CodeBlock>
          <p><strong>Файл 2:</strong></p>
          <CodeBlock>СОЗ_Карточка_Наименование организации.pdf</CodeBlock>
        </Rule>
        <Rule number="4" title="Одно заявление = один объект защиты">
          <p>В одном письме должны содержаться документы только по одному объекту защиты.</p>
        </Rule>
        <Rule number="5" title="Отправитель">
          <p>Заявления принимаются исключительно от правообладателя объекта защиты.</p>
        </Rule>
        <Rule number="6" title="Защита от дублирования">
          <p>Повторная отправка идентичного уведомления автоматически отклоняется как дубликат.</p>
        </Rule>
      </SectionBlock>

      <SectionBlock icon={<FaDownload />} title="Пример карточки объекта" isTemplate>
        <p className="appealsInstructionsPage__text">
          Заполните, подпишите и приложите к письму в формате PDF.
        </p>
        <div className="appealsInstructionsPage__actions">
          <a
            href={downloads.sozCard.href}
            download={downloads.sozCard.name}
            className="appealsInstructionsPage__button"
          >
            <FaDownload />
            Скачать пример карточки (.docx)
          </a>
        </div>
      </SectionBlock>

      <TemplateBlock id="soz" title="Готовый образец заявления" copiedKey={copiedKey} onCopy={onCopy} />
    </InstructionCard>
  );
}

function TzTab({ copiedKey, onCopy }) {
  return (
    <InstructionCard icon={<FaCompass />} title="Запрос технического задания на проектирование">
      <SectionBlock icon={<FaInfoCircle />} title="Нормативное обоснование">
        <p>
          В соответствии с <strong>пунктом 4.1</strong> Порядка правообладатель
          объекта защиты обращается за выдачей технического задания на
          проектирование для подключения системы пожарной сигнализации.
        </p>
        <p>
          Техническое задание содержит информацию, необходимую для сопряжения
          приборов и ввода системы передачи извещений о пожаре в эксплуатацию.
        </p>
      </SectionBlock>

      <SectionBlock icon={<FaClock />} title="Режим работы">
        <div className="appealsInstructionsPage__schedule">
          <div className="appealsInstructionsPage__schedule-row">
            <span className="appealsInstructionsPage__schedule-label">Рабочие дни:</span>
            <span>Пн–Чт: 09:00 – 18:00</span>
            <span>Пт: 09:00 – 17:00</span>
          </div>
          <div className="appealsInstructionsPage__schedule-row">
            <span className="appealsInstructionsPage__schedule-label">Обед:</span>
            <span>13:00 – 13:48</span>
          </div>
        </div>
      </SectionBlock>

      <SectionBlock icon={<FaFileAlt />} title="Требования к оформлению заявления">
        <Rule number="1" title="Тема письма" required="(строго по формату)">
          <CodeBlock>ТЗ_ПРОЕКТИРОВАНИЕ / Полное наименование организации / ДД.ММ.ГГГГ / Исх. №</CodeBlock>
          <Notice type="example" icon={<FaMapMarkerAlt />}>
            <p><strong>Пример:</strong> «ТЗ_ПРОЕКТИРОВАНИЕ / ООО "Пожарная Безопасность" / 25.06.2026 / Исх. № 45»</p>
          </Notice>
        </Rule>
        <Rule number="2" title="Вложение" required="(строго один файл)">
          <Notice type="warning" icon={<FaExclamationTriangle />}>
            <ul>
              <li>заявление оформляется на официальном бланке;</li>
              <li>подписывается руководителем организации;</li>
              <li>предоставляется в формате PDF;</li>
              <li>количество вложений: ровно одно.</li>
            </ul>
          </Notice>
          <CodeBlock>
            ТЗ_Проектирование_Заявление_Наименование организации.pdf
          </CodeBlock>
        </Rule>
        <Rule number="3" title="Одно заявление = один объект">
          <p>В одном письме должно содержаться заявление только по одному объекту защиты.</p>
        </Rule>
        <Rule number="4" title="Отправитель">
          <p>Заявление подается исключительно от правообладателя объекта защиты.</p>
        </Rule>
      </SectionBlock>

      <TemplateBlock id="tz" title="Готовый образец заявления" copiedKey={copiedKey} onCopy={onCopy} />
    </InstructionCard>
  );
}

function ConnectionTab({ copiedKey, onCopy }) {
  return (
    <InstructionCard icon={<FaPlug />} title="Заявление на подключение">
      <SectionBlock icon={<FaInfoCircle />} title="Нормативное обоснование">
        <p>
          В соответствии с <strong>пунктом 4.2</strong> Порядка правообладатель
          объекта защиты направляет заявление о подключении системы пожарной
          сигнализации к прибору пультовому оконечному ПАК «Стрелец-Мониторинг».
        </p>
      </SectionBlock>

      <SectionBlock icon={<FaInfoCircle />} title="Для чего нужно">
        <p>
          Для подключения объекта к системе «Стрелец-Мониторинг» и передачи
          сигнала на пульт централизованного наблюдения.
        </p>
      </SectionBlock>

      <SectionBlock icon={<FaPaperclip />} title="Что приложить к письму">
        <ul className="appealsInstructionsPage__list">
          <li>Проектную документацию на оснащение объекта прибором объектовым оконечным.</li>
          <li>Техническую документацию изготовителя на установленный прибор.</li>
          <li>Акт выполненных монтажных и пусконаладочных работ.</li>
          <li>Акт ввода в эксплуатацию системы пожарной сигнализации.</li>
          <li>Копию договора на техническое обслуживание прибора.</li>
          <li>Выписку из электронного сервиса МЧС России «Реестры лицензий МЧС России в области пожарной безопасности».</li>
        </ul>
      </SectionBlock>

      <SectionBlock icon={<FaFileAlt />} title="Требования к оформлению заявления">
        <Rule number="1" title="Тема письма" required="(строго по формату)">
          <CodeBlock>ПОДКЛЮЧЕНИЕ / Полное наименование организации / ДД.ММ.ГГГГ / Исх. №</CodeBlock>
          <Notice type="example" icon={<FaMapMarkerAlt />}>
            <p><strong>Пример:</strong> «ПОДКЛЮЧЕНИЕ / ООО "Пожарная Безопасность" / 25.06.2026 / Исх. № 45»</p>
          </Notice>
        </Rule>
      </SectionBlock>

      <TemplateBlock id="connection" title="Готовый образец заявления" copiedKey={copiedKey} onCopy={onCopy} />
    </InstructionCard>
  );
}

function GeneralTab() {
  return (
    <InstructionCard icon={<FaQuestionCircle />} title="Общие вопросы">
      <SectionBlock icon={<FaPen />} title="Формат темы письма для общих обращений">
        <p>
          Чтобы обращение было быстро распознано и направлено нужному специалисту,
          указывайте тему письма строго по формату:
        </p>
        <CodeBlock>ОБЩЕЕ / Полное наименование организации / ДД.ММ.ГГГГ / Исх. №</CodeBlock>
        <DetailsList>
          <li>ОБЩЕЕ — служебный признак, по которому письмо относится к общим вопросам.</li>
          <li>Полное наименование организации — правообладатель объекта защиты.</li>
          <li>ДД.ММ.ГГГГ — дата направления обращения.</li>
          <li>Исх. № — исходящий номер вашего внутреннего письма.</li>
        </DetailsList>
        <Notice type="example" icon={<FaMapMarkerAlt />}>
          <p><strong>Пример:</strong> «ОБЩЕЕ / ООО "Пожарная Безопасность" / 25.06.2026 / Исх. № 123»</p>
        </Notice>
      </SectionBlock>
    </InstructionCard>
  );
}

function Attachment({ number, title, text }) {
  return (
    <div className="appealsInstructionsPage__attachment">
      <span className="appealsInstructionsPage__attachment-number">{number}</span>
      <div>
        <strong>{title}</strong>
        <p>{text}</p>
      </div>
    </div>
  );
}

function InstructionCard({ icon, title, children }) {
  return (
    <article className="appealsInstructionsPage__card">
      <header className="appealsInstructionsPage__card-header">
        <span className="appealsInstructionsPage__card-icon">{icon}</span>
        <h3 className="appealsInstructionsPage__card-title">{title}</h3>
      </header>
      <div className="appealsInstructionsPage__card-body">{children}</div>
    </article>
  );
}

function AppealsInstructionsPage() {
  const [activeTab, setActiveTab] = useState('reglament');
  const [copiedKey, setCopiedKey] = useState('');

  function handleCopy(key, text) {
    copyText(text)
      .then(() => {
        setCopiedKey(key);
        window.setTimeout(() => setCopiedKey(''), 2000);
      })
      .catch(() => {
        setCopiedKey('');
      });
  }

  return (
    <>
      <Header />
      <main className="content">
        <section className="appealsInstructionsPage">
          <div className="appealsInstructionsPage__hero">
            <p className="appealsInstructionsPage__eyebrow">Стрелец-Мониторинг</p>
            <h2 className="appealsInstructionsPage__title">
              Инструкции по оформлению обращений
            </h2>
            <p className="appealsInstructionsPage__lead">
              Выберите тему обращения, чтобы проверить правила заполнения,
              требования к вложениям и получить готовый текст заявления.
            </p>
          </div>

          <div className="appealsInstructionsPage__mail-panel">
            <span className="appealsInstructionsPage__mail-icon">
              <FaEnvelope />
            </span>
            <div className="appealsInstructionsPage__mail-content">
              <span className="appealsInstructionsPage__mail-label">
                Все заявления направляйте на единый адрес:
              </span>
              <a href={`mailto:${RECIPIENT_EMAIL}`} className="appealsInstructionsPage__mail-link">
                {RECIPIENT_EMAIL}
              </a>
            </div>
            <button
              type="button"
              className={`appealsInstructionsPage__button appealsInstructionsPage__mail-copy${
                copiedKey === 'email' ? ' appealsInstructionsPage__button_success' : ''
              }`}
              onClick={() => handleCopy('email', RECIPIENT_EMAIL)}
            >
              <FaCopy />
              {copiedKey === 'email' ? 'Скопировано' : 'Скопировать'}
            </button>
          </div>

          <div className="appealsInstructionsPage__tabs" role="tablist" aria-label="Тип обращения">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={`appealsInstructionsPage__tab${
                  activeTab === tab.id ? ' appealsInstructionsPage__tab_active' : ''
                }`}
                onClick={() => setActiveTab(tab.id)}
                role="tab"
                aria-selected={activeTab === tab.id}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {activeTab === 'reglament' && <ReglamentTab copiedKey={copiedKey} onCopy={handleCopy} />}
          {activeTab === 'repair' && <RepairTab copiedKey={copiedKey} onCopy={handleCopy} />}
          {activeTab === 'soz' && <SozTab copiedKey={copiedKey} onCopy={handleCopy} />}
          {activeTab === 'tz' && <TzTab copiedKey={copiedKey} onCopy={handleCopy} />}
          {activeTab === 'connection' && <ConnectionTab copiedKey={copiedKey} onCopy={handleCopy} />}
          {activeTab === 'general' && <GeneralTab />}
        </section>
      </main>
      <Footer />
    </>
  );
}

export default AppealsInstructionsPage;
